module.exports = __webpack_public_path__ + "img/avatar-vr.1ed237f5.png";